import React from 'react';
import { FuseNavigation } from '@fuse';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(()=> ({
	root: {
		'overflow-x': 'hidden'
	}
}));

const Navigation = props => {
	const navigation = useSelector(({ fuse }) => fuse.navigation);
	const classes = useStyles();

	return (
		<FuseNavigation
			className={clsx(classes.root, 'navigation', props.className)}
			navigation={navigation}
			layout={props.layout}
			dense={props.dense}
		/>
	);
};

Navigation.defaultProps = {
	layout: 'vertical'
};

export default Navigation;
